import { NotificationPreferences } from '@/components/notifications/NotificationPreferences';
import { AdminNotificationSettings } from '@/components/notifications/AdminNotificationSettings';
import { NavHeader } from '@/components/layout/nav-header';

export function NotificationPreferencesPage() {
  return (
    <div className="min-h-screen bg-clubhouse-black">
      <NavHeader />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-white mb-8">Settings</h1>
        <NotificationPreferences />
        <AdminNotificationSettings />
      </div>
    </div>
  );
}